import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { teceoGrayHoveredBackground, teceoOrangeSelectedRow } from '../../../../../../../../Theme';
import { getGridSurface } from '../../../../../../styles/gridScrollFade';

export const usePackStyles = makeStyles()((theme: Theme) => ({
  gridName: {
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    paddingTop: 1,
  },

  title: {
    textTransform: 'uppercase',
  },

  multiplierTextField: {
    maxWidth: 40,
    background: theme.palette.background.paper,
  },

  mobileMultiplierSelector: {
    borderRadius: theme.shape.borderRadius,
    position: 'relative',
    width: 91,
    height: 38,
  },
  mobileMultiplierDefaultBorder: {
    border: `1px solid ${theme.palette.custom.border.primary}`,
  },
  mobileMultiplierErrorBorder: {
    border: `1px solid ${theme.palette.error.light} !important`,
  },

  mobileMultiplierTextField: {
    borderRadius: '4px',
    width: '60%',
    '& .MuiOutlinedInput-input': {
      padding: '4px 2px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiInputBase-input': {
      '-moz-appearance': 'textfield',
      textAlign: 'center',
    },
  },

  addOrSubtract: {
    width: '100%',
    height: 36,
  },
  multiplierInput: {
    height: 26,
  },
  icon: {
    width: 14,
    height: 14,
  },

  virtuoso: {
    [theme.breakpoints.down('sm')]: {
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  },

  headerContainer: {
    borderBottom: `1px solid ${teceoGrayHoveredBackground}`,
  },

  headerTitleContainer: {
    borderBottom: `1px solid ${teceoGrayHoveredBackground}`,
    padding: parseInt(theme.spacing()) * 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'sticky',
  },

  headerSubTitleContainer: {
    padding: parseInt(theme.spacing()) * 2,
    display: 'flex',
    flexDirection: 'column',
    gap: parseInt(theme.spacing()) * 2,
    position: 'sticky',
  },

  menuItemDesktopContainer: {
    width: '100%',
    padding: `${theme.spacing()} 0px`,
    margin: `${theme.spacing()} 0px`,
  },

  itemsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gridRowGap: parseInt(theme.spacing()) * 2,
    width: '100%',
    padding: `${theme.spacing()} 0`,
    margin: `${theme.spacing()} 0`,
  },

  itemContainer: {
    display: 'flex',
    gap: theme.spacing(),
  },

  sizeQuantityItemContainer: {
    width: 40,
    display: 'flex',
    flexDirection: 'column',
  },

  itemRow: {
    [theme.breakpoints.up('sm')]: {
      color: theme.palette.action.disabled,
      '&:hover': {
        backgroundColor: theme.palette.background.default,
        ...getGridSurface({ base: theme.palette.background.default }),
      },
      '&:hover > .stickyPackNameStylesPropagation': {
        backgroundColor: theme.palette.background.default,
      },
      '&:hover > .stickyPackMultiplierStylesPropagation': {
        backgroundColor: theme.palette.background.default,
      },
      '&:hover .shadowContainer': {
        boxShadow: 'none',
      },
      borderRadius: 8,
    },
  },

  cursorPointer: {
    [theme.breakpoints.up('sm')]: {
      cursor: 'pointer',
    },
  },

  cursorUnset: {
    [theme.breakpoints.up('sm')]: {
      cursor: 'unset',
    },
  },

  selectedItemRow: {
    backgroundColor: teceoOrangeSelectedRow,
    '& .stickyPackNameStylesPropagation': {
      backgroundColor: 'rgba(255, 112, 61, 0.00)',
    },
    '& .stickyPackMultiplierStylesPropagation': {
      backgroundColor: 'rgba(255, 112, 61, 0.00)',
    },
    ...getGridSurface({ base: teceoOrangeSelectedRow }),
    '& .shadowContainer': {
      boxShadow: 'none',
    },
  },

  errorItemRow: {
    backgroundColor: 'rgba(255, 0, 0, 0.05)',
    '& .stickyPackNameStylesPropagation': {
      backgroundColor: 'rgba(255, 0, 0, 0.00)',
    },
    '& .stickyPackMultiplierStylesPropagation': {
      backgroundColor: 'rgba(255, 0, 0, 0.00)',
    },
  },

  errorIcon: {
    paddingLeft: '9px',
    paddingRight: '9px',
  },

  stickyPackMultiplier: {
    position: 'sticky',
    [theme.breakpoints.down('sm')]: {
      left: window.innerWidth - 130,
    },
  },

  stockQuantity: {
    position: 'absolute',
    backgroundColor: 'white',
    borderRadius: 4,
    bottom: -9,
    [theme.breakpoints.up('sm')]: {
      left: 40,
    },
    [theme.breakpoints.down('sm')]: {
      left: 40,
    },
  },
}));
